import React, { useEffect, useState } from 'react';
import { propTypesComponentPaymentInput } from '../../shared.propTypes';
import styles from '../PaymentInputCreditCardLegacy/PaymentInputCreditCardLegacy.module.css';
import SelectionItem from '../../../SelectionItem/SelectionItem';
import stylesShared from '../../shared.module.css';
import Button from '../../../Button/Button';
import { keyDownA11y } from '../../shared';
import {
  getCheckoutBackIcon,
  getCheckoutCheckIconSrc,
  getCheckoutPartProps,
  isReviewOrderBrandRefresh,
} from '../../../../pages/ReviewOrder/reviewOrderBrandRefreshClasses';

const ccIcon = require('../../imgs/cc-icon.svg');
const brandRefreshCcIcon = require('../../imgs/brand-refresh-cc-icon.svg');
const brandRefreshPlus = require('./imgs/brand-refresh-plus.svg');

const handleSubmit = (card, storePaymentMethod, callback) => {
  const paymentCredentialSubmitted = {
    summary: `Card ending in ${card.last4}`,
    storePaymentMethod,
    paymentCredential: {
      paymentMethodId: Number(card.paymentMethodId),
      credential: card.transactionId,
      securityCode: null,
      saveCredentials: false,
      paymentProcessorId: Number(card.paymentProcessorId),
    }
  };

  callback(paymentCredentialSubmitted);
};

const PaymentInputCreditCardSavedList = props => {

  const {
    storePaymentMethod,
    onSubmitPaymentCredentials,
    paymentCredentialSubmitted,
    onCancel,
    hideCancel,
    paymentMethodsCustomerSaved,
    hidden,
    onAddNewCardClick
  } = props;

  const brandRefresh = isReviewOrderBrandRefresh();
  const [selectedCard, setSelectedCard] = useState(
    paymentMethodsCustomerSaved && paymentMethodsCustomerSaved.length === 1 ? paymentMethodsCustomerSaved[0] : null
  );

  useEffect(() => {
    // if the submitted payment credential changed, and it's not a saved card in the saved card list,
    // then unselect the selected saved card
    if (!(paymentCredentialSubmitted && paymentMethodsCustomerSaved && setSelectedCard)) return;

    const {
      paymentCredential: { credential }
    } = paymentCredentialSubmitted;
    const isCredentialInCustomerSavedList = paymentMethodsCustomerSaved.some(
      card => card.transactionId === credential
    );
    if (!isCredentialInCustomerSavedList) {
      setSelectedCard(null);
    }
  }, [paymentCredentialSubmitted, paymentMethodsCustomerSaved, setSelectedCard]);

  return (
    <div
      hidden={hidden}
      data-part={getCheckoutPartProps('saved-payment-methods')}
    >
      <p
        className={styles.sectionSubHeader}
        data-part={getCheckoutPartProps('saved-payment-methods-title')}
      >
        {brandRefresh ? 'Saved payment methods' : 'Saved Payment Methods'}
      </p>
      <div data-part={getCheckoutPartProps('saved-payment-methods-list')}>
        {paymentMethodsCustomerSaved && paymentMethodsCustomerSaved.length > 0
          ? paymentMethodsCustomerSaved.map(card => (
            <SelectionItem
              key={card.last4}
              main={false}
              asset={getCheckoutBackIcon(ccIcon, brandRefreshCcIcon)}
              label={card.cardType}
              header={`Ending ${card.last4}`}
              isSelected={card.last4 === selectedCard?.last4}
              onSelect={() => setSelectedCard(card)}
              checkIconSrc={getCheckoutCheckIconSrc()}
              dataPart={getCheckoutPartProps('saved-payment-card')}
              hideLabel={brandRefresh}
            />
            ))
          : null}
      </div>
      <div
        className={[stylesShared.footerActions, stylesShared.footerActionLeft].join(' ')}
        onClick={onAddNewCardClick}
        hidden={hideCancel}
        onKeyDown={keyDownA11y(onAddNewCardClick)}
        role="button"
        tabIndex={0}
        data-part={getCheckoutPartProps('add-new-card')}
      >
        {brandRefresh ? (
          <>
            <img alt="" src={brandRefreshPlus} data-part={getCheckoutPartProps('add-new-card-icon')} />
            <span>Add New Card</span>
          </>
        ) : (
          'Add New Card'
        )}
      </div>
      <div
        className={styles.buttonContainer}
        data-part={getCheckoutPartProps('saved-payment-actions')}
      >
        <Button
          disabled={!selectedCard}
          handleSubmit={() => {
            handleSubmit(selectedCard, storePaymentMethod, onSubmitPaymentCredentials);
          }}
          label="Save Changes"
        />
        {!hideCancel ? (
          <div
            className={stylesShared.footerActions}
            hidden={hideCancel}
            onClick={onCancel}
            onKeyDown={keyDownA11y(onCancel)}
            role="button"
            tabIndex={0}
            data-part={getCheckoutPartProps('change-payment-method')}
          >
            Change Payment Method
          </div>
        ) : null}
      </div>
    </div>
  );
};

PaymentInputCreditCardSavedList.propTypes = propTypesComponentPaymentInput;

export default PaymentInputCreditCardSavedList;
